export const MAPBOX_BASE_SATELLITE = {
    "version": 8,
    "sources": {
        "raster-tiles": {
            "type": "raster",
            "tiles": [
                `https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}@1x.jpg90?access_token=${process.env.REACT_APP_MAPBOX_TOKEN}`
            ],
            "tileSize": 256,
            "attribution": ""
        }
    },
    "glyphs": "http://fonts.openmaptiles.org/{fontstack}/{range}.pbf",
    "layers": [{
            "id": "mapbox-tiles",
            "type": "raster",
            "source": "raster-tiles",
            "minzoom": 0,
            "maxzoom": 24
        }
    ]
}